module.exports = __webpack_public_path__ + "img/code-css-md.c209f3d9.webp";